import type { StepSnapshot, StepSignal } from './types';

export const INITIAL_SNAPSHOT: StepSnapshot = {
  ready: false,
  isDirty: false,
  isSubmitting: false,
  isLoading: false,
  lastValidation: 'none',
  lastResult: null,
  lastError: null,
  lastValues: null,
  customState: {},
};

export function reduceSnapshot(
  state: StepSnapshot,
  signal: StepSignal,
): StepSnapshot {
  switch (signal.type) {
    case 'READY':
      return { ...state, ready: true };

    case 'DIRTY_CHANGED':
      return { ...state, isDirty: signal.isDirty };

    case 'VALIDATION_SUCCESS':
      return {
        ...state,
        lastValidation: 'success',
        lastValues: signal.values,
      };

    case 'VALIDATION_FAILURE':
      return {
        ...state,
        lastValidation: 'failure',
        lastError: signal.errors,
      };

    case 'SUBMIT_STARTED':
      return { ...state, isSubmitting: true };

    case 'SUBMIT_SUCCESS':
      return {
        ...state,
        isSubmitting: false,
        lastResult: signal.result,
        lastError: null,
      };

    case 'SUBMIT_FAILURE':
      return {
        ...state,
        isSubmitting: false,
        lastError: signal.error,
      };

    case 'VALUES_COLLECTED':
      return { ...state, lastValues: signal.values };

    case 'LOADING_CHANGED':
      return { ...state, isLoading: signal.isLoading };

    case 'CUSTOM':
      return {
        ...state,
        customState: { ...state.customState, [signal.key]: signal.payload },
      };
  }
}
